import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import RenewToken from './RenewToken';
import Loading from '../components/Loading';
import useAuth from "./useAuth";

const AuthRoute = ({component: Component, ...rest}) => {
    const {me, loading} = useAuth();

    return (
        <Route {...rest} render={(props) => {
            if (typeof me === 'undefined') {
                if (!loading) {
                    return (

                        <Redirect to='/login'/>
                    );
                }
                return <Loading/>;
            }
            return (
                <RenewToken>
                    <Component {...props} />
                </RenewToken>
            );


        }}/>
    );
}

export default AuthRoute;
